import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(example, pagable);
    return httpService.get("userDeptRoleView", { params: params });
  },

  findAllFiltered(example, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(example, pagable);
    return httpService.get("userDeptRoleView/findAllFiltered", { params: params });
  },

  findAllCopy(example, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(example, pagable);
    return httpService.get("userDeptRoleViewCopy", { params: params });
  },

  findAllCopyFiltered(example, pagable) {
    pagable = utils.initPageableParams(pagable);
    let params = utils.merge(example, pagable);
    return httpService.get("userDeptRoleViewCopy/findAllFiltered", { params: params });
  },

  findAll2(deptIds, roleIds, status, pagable) {
    let params = utils.merge(
      { deptIds: deptIds, roleIds: roleIds, status: status },
      pagable
    );
    return httpService.get("userDeptRoleView/findAll2", { params: params });
  },

  search(keyword, pageable, deptId) {
    pageable = utils.initPageableParams(pageable);
    return httpService.get("userDeptRoleView/search", {
      params: {
        keyword: keyword,
        deptId: deptId,
        page: pageable.page,
        size: pageable.size,
        sort: pageable.sort
      }
    });
  },

  findAllForHashTag(keyword, pageable, deptId) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      {
        keyword: keyword,
        deptId: deptId
      },
      pageable
    );
    return httpService.get("userDeptRoleView/findAllForHashTag", {
      params: params
    });
  },

  findById(id) {
    return httpService.get("userDeptRoleView/" + id);
  },

  findAllByIdIn(ids) {
    return httpService.get("userDeptRoleView/findByIdIn", {
      params: { ids: ids }
    });
  },

  findAllByVbIncomingDoc(vbIncomingDocId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({ vbIncomingDocId: vbIncomingDocId }, pageable);
    return httpService.get("userDeptRoleView/findAllByVbIncomingDoc", {
      params: params
    });
  },

  findAllByVbOutgoingDoc(vbOutgoingDocId, query, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { vbOutgoingDocId: vbOutgoingDocId, query: query },
      pageable
    );
    return httpService.get("userDeptRoleView/findAllByVbOutgoingDoc", {
      params: params
    });
  },

  findAllForDocOutCC(deptId, docId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({ deptId: deptId, docId: docId }, pageable);
    return httpService.get("userDeptRoleView/findAllForDocOutCC", {
      params: params
    });
  },

  findAllForDocOutCCDefault(deptId, docId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({ deptId: deptId, docId: docId }, pageable);
    return httpService.get("userDeptRoleView/findAllForDocOutCCDefault", {
      params: params
    });
  },

  findAllReceiversForTask(parentTaskId, keyword, pageable, delegatorId) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      {
        parentTaskId: parentTaskId,
        keyword: keyword,
        delegatorId: delegatorId
      },
      pageable
    );
    return httpService.get("userDeptRoleView/findAllReceiversForTask", {
      params: params
    });
  },

  findAllDelegatorByToUser() {
    return httpService.get("userDeptRoleView/findAllDelegatorByToUser");
  },

  findAllCoordinatorForTask(taskId, pageable, delegatorId) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { taskId: taskId, delegatorId: delegatorId },
      pageable
    );
    return httpService.get("userDeptRoleView/findAllCoordinatorForTask", {
      params: params
    });
  },

  findAllAssignersForTask(pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = pageable;
    return httpService.get("userDeptRoleView/findAllAssignersForTask", {
      params: params
    });
  },

  findAllForDelegate(query, roleCodes, fromUserDeptRoleId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      {
        query: query,
        roleCodes: roleCodes,
        fromUserDeptRoleId: fromUserDeptRoleId
      },
      pageable
    );
    return httpService.get("userDeptRoleView/findAllForDelegate", {
      params: params
    });
  },

  findAllActiveForStepInfo(vbStepInfo, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({ vbStepInfo: vbStepInfo }, pageable);
    return httpService.get("userDeptRoleView/findAllActiveForStepInfo", {
      params: params
    });
  },

  findAllForDongTrinh(deptId, pageable) {
    let params = utils.merge(
      { deptId: deptId },
      utils.initPageableParams(pageable)
    );
    return httpService.get("userDeptRoleView/findAllForDongTrinh", {
      params: params
    });
  },

  findAllForBanHanh(docId) {
    let params = { docId: docId };
    return httpService.get("userDeptRoleView/findAllForBanHanh", {
      params: params
    });
  },

  findAllByCurrentUser() {
    return httpService.get(`/userDeptRoleView/findAllByCurrentUser`);
  },

  findAllSignerForCreateKyNgoai(publisherId, pageable) {
    let params = utils.merge(pageable, { publisherId: publisherId });
    return httpService.get(`/userDeptRoleView/findAllSignerForCreateKyNgoai`, {
      params: params
    });
  },

  findSignerByOutgoingDoc(docId) {
    return httpService.get(`/userDeptRoleView/findSignerByOutgoingDoc`, {
      params: { docId: docId }
    });
  },

  findAllForSharingHcCaseCalendar(hcCaseCalendarId, query, pageable) {
    let params = utils.merge(
      { query: query, hcCaseCalendarId: hcCaseCalendarId },
      utils.initPageableParams(pageable)
    );
    return httpService.get("userDeptRoleView/findAllForSharingHcCaseCalendar", {
      params: params
    });
  },

  findAllForLichTuan(deptId, pageable) {
    let params = utils.merge({ deptId }, utils.initPageableParams(pageable));
    return httpService.get("userDeptRoleView/findAllForLichTuan", {
      params: params
    });
  },

  findAllByActorGroup(actorGroup) {
    return httpService.get("userDeptRoleView/findAllByActorGroup", {
      params: { actorGroup }
    });
  },

  findAllHcCaseCalendarLeaders(hcCaseCalendarId) {
    return httpService.get("userDeptRoleView/findAllHcCaseCalendarLeaders", {
      params: { hcCaseCalendarId }
    });
  },

  findAllForRankingScore(keyword, includeId) {
    return httpService.get("userDeptRoleView/findAllForRankingScore", {
      params: { keyword, includeId: includeId }
    });
  },

  findAllForBaoCaoTinhHinhXLVb() {
    return httpService.get("userDeptRoleView/findAllForBaoCaoTinhHinhXLVb");
  },

  findAllReceiversForTaskV2() {
    return httpService.get("userDeptRoleView/findAllReceiversForTaskV2");
  },

  findAllForHcCommands(deptId) {
    let params = { deptId: deptId };
    return httpService.get("userDeptRoleView/findAllForHcCommands", {
      params: params
    });
  },

  findAllLDDVForHcCommands(deptId) {
    let params = { deptId: deptId };
    return httpService.get("userDeptRoleView/findAllLDDVForHcCommands", {
      params: params
    });
  },

  findAllCVDVForHcCommands(deptId) {
    let params = { deptId: deptId };
    return httpService.get("userDeptRoleView/findAllCVDVForHcCommands", {
      params: params
    });
  },

  findRequesterForHc(hcCaseMasterId) {
    let params = { hcCaseMasterId: hcCaseMasterId };
    return httpService.get("userDeptRoleView/findRequesterForHc", {
      params: params
    });
  },

  findAllTaskCooperators(tkTaskId) {
    let params = { tkTaskId: tkTaskId };
    return httpService.get("userDeptRoleView/findAllTaskCooperators", {
      params: params
    });
  },

  findByEmail(email) {
    let params = { email: email };
    return httpService.get("userDeptRoleView/findByEmail", {
      params: params
    });
  },

  findAllForHcPhongHopOtherInvoled(query, deptId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({ query, deptId }, pageable);
    return httpService.get(
      "userDeptRoleView/findAllForHcPhongHopOtherInvoled",
      {
        params: params
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/userDeptRoleViewService.js